import React, { Component } from "react"
import { translate } from "react-translate"
import SegmentGroup, {
  Button,
  Grid,
  Icon,
  Modal,
  Label,
  Container,
  Input,
  Dropdown,
  Segment,
  Form
} from "semantic-ui-react"
import "./ModalDevisDocument.css"
import _ from "lodash"

import DevisFactureService from "../DevisFactureService"

const optionsStatuts = [
  { key: "accepté", text: "value_dropdown_accepté", value: "accepté" },
  { key: "finalisé", text: "value_dropdown_finalisé", value: "finalisé" },
  { key: "brouillon", text: "value_dropdown_brouillon", value: "brouillon" },
  { key: "abandonné", text: "value_dropdown_abandonné", value: "abandonné" }
]

class ModalDevisDocument extends Component {
  constructor(props) {
    super(props)
    this.state = { modalOpen: false }
  }

  handleOpen = () => this.setState({ modalOpen: true })

  handleClose = () => this.setState({ modalOpen: false })

  componentWillMount() {
    DevisFactureService.fetchData().then(response => {
      this.setState({ rawData: response })
    })

    var devisFacture = this.state.rawData
    let { t } = this.props
    var optionsStatutsCopy = _.clone(optionsStatuts)
    optionsStatutsCopy = _.map(optionsStatutsCopy, x => {
      return {
        ...x,
        text: t(x.text)
      }
    })

    this.setState({
      optionsStatuts: optionsStatutsCopy
    })

    DevisFactureService.fetchData().then(response => {
      var devisOptions = _.map(response, x => {
        return {
          text: x.reference,
          key: x.reference,
          value: x.reference
        }
      })

      this.setState({
        devisFinalOption: devisOptions
      })
    })
  }

  eventHandler(event) {
    this.setState({
      toggle: event
    })
  }

  render() {
    let { t } = this.props
    var callbackNewDevis = this.props.newDevis || function() {}
    return (
      <Modal
        id="contentModal"
        trigger={
          <Button id="creation" onClick={this.handleOpen}>
            {" "}
            <Icon
              className="plus circle"
              icons="plus circle"
              name="plus circle"
            />
            {t("button_modal_create")}
          </Button>
        }
        open={this.state.modalOpen}
        onClose={this.handleClose}
      >
        <Modal.Header id="modalHeaderDocument">
          {t("title_modal_create_document")}
        </Modal.Header>
        <Modal.Content scrolling="true">
          <Modal.Description>
            <Container>
              <Form id="formChantier">
                <Form.Field>
                  <label className="modalMargin">
                    {t("input_modal_chantier")}
                  </label>
                  <Input
                    fluid
                    placeholder={t("placeholder_modal_chantier")}
                    id="chantierInputModal"
                    onChange={(e, val) => this.setState({ name: val.value })}
                  />
                </Form.Field>
                <Form.Field id="inputName">
                  <label>{t("input_modal_name")}</label>
                  <Input
                    placeholder={t("placeholder_modal_name")}
                    id="chantierInputModal"
                    onChange={(e, val) =>
                      this.setState({ nameClient: val.value })
                    }
                  />
                </Form.Field>
                <Form.Field id="inputAdress">
                  <label>{t("input_modal_adress")}</label>
                  <Input
                    placeholder={t("placeholder_modal_adress")}
                    id="chantierInputModal"
                    onChange={(e, val) => this.setState({ adresse: val.value })}
                  />
                </Form.Field>
              </Form>
            </Container>
            <Container>
              <Form>
                <Form.Field>
                  <label className="modalMargin">
                    {t("input_modal_created")}
                  </label>
                  <Segment id="segmentCard">
                    <Grid columns={5}>
                      <Grid.Row id="ligneCard">
                        <Grid.Column>
                          <Button
                            id="cardDocument"
                            onClick={() => this.eventHandler("devis")}
                            onChange={(e, val) =>
                              this.setState({ type: "devis" })
                            }
                          >
                            <Icon
                              id="iconModalDocument"
                              className="sticky note outline"
                              size="huge"
                            />
                          </Button>
                          <label id="cardName">
                            {t("select_modal_devis_vierge")}
                          </label>
                        </Grid.Column>
                        <Grid.Column>
                          <Button
                            id="cardDocument"
                            onClick={() => this.eventHandler("facture")}
                            onChange={(e, val) =>
                              this.setState({ type: "facture" })
                            }
                          >
                            <Icon
                              id="iconModalDocument"
                              className="file outline"
                              size="huge"
                            />
                          </Button>
                          <label id="cardName">
                            {t("select_modal_facture_vierge")}
                          </label>
                        </Grid.Column>
                        <Grid.Column>
                          <Button
                            id="cardDocument"
                            onClick={() => this.eventHandler("facture")}
                            onChange={(e, val) =>
                              this.setState({ type: "facture" })
                            }
                          >
                            <Icon
                              id="iconModalDocument"
                              className="file"
                              size="huge"
                            />
                          </Button>
                          <label id="cardName">
                            {t("select_modal_facture_acompte")}
                          </label>
                        </Grid.Column>
                        <Grid.Column>
                          <Button
                            id="cardDocument"
                            onClick={() => this.eventHandler("facture")}
                            onChange={(e, val) =>
                              this.setState({ type: "facture" })
                            }
                          >
                            <Icon
                              id="iconModalDocument"
                              className="file alternate outline"
                              size="huge"
                            />
                          </Button>
                          <label id="cardName">
                            {t("select_modal_facture_intermediaire")}
                          </label>
                        </Grid.Column>
                        <Grid.Column>
                          <Button
                            id="cardDocument"
                            onClick={() => this.eventHandler("facture")}
                            onChange={(e, val) =>
                              this.setState({ type: "facture" })
                            }
                          >
                            <Icon
                              id="iconModalDocument"
                              className="file alternate"
                              size="huge"
                            />
                          </Button>
                          <label id="cardName">
                            {t("select_modal_facture_final")}
                          </label>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Segment>
                </Form.Field>
              </Form>
            </Container>
            <Container>
              <Form id="inputDropdownDocument">
                <Form.Field>
                  <label className="modalMargin">
                    {t("label_modal_since")}
                  </label>
                  <Dropdown
                    id="devisFiltre"
                    placeholder={t("placeholder_modal_since")}
                    fluid
                    options={this.state.devisFinalOption || []}
                    selection
                    disabled={this.state.toggle == "devis"}
                    onChange={(e, val) =>
                      this.setState(
                        { statut: val.value },
                        console.log(
                          "state dropdown",
                          this.state.devisFinalOption
                        )
                      )
                    }
                  />
                </Form.Field>
              </Form>
            </Container>
            <Container>
              <Form>
                <Form.Field>
                  <label className="modalMargin">
                    {t("label_modal_amount")}
                  </label>
                  <Segment id="modalMontantDocument">
                    <Input
                      id="inputMontant"
                      labelPosition="right"
                      type="text"
                      placeholder={t("placeholder_modal_amount_%")}
                    >
                      <Input
                        id="inputValue"
                        onChange={(e, val) =>
                          this.setState({ pourcentage: val.value })
                        }
                      />
                      <Label id="inputMontantLabel">{t("label_modal_%")}</Label>
                    </Input>
                    <Input
                      id="inputMontant"
                      labelPosition="right"
                      type="text"
                      placeholder={t("placeholder_modal_amount_€_first")}
                    >
                      <Input
                        id="inputValue"
                        onChange={(e, val) =>
                          this.setState({ price: Number(val.value) })
                        }
                      />
                      <Label id="inputMontantLabel">{t("label_modal_€")}</Label>
                    </Input>
                    <Input
                      id="inputMontant"
                      labelPosition="right"
                      type="text"
                      placeholder={t("placeholder_modal_amount_€_second")}
                    >
                      <Input
                        id="inputValue"
                        onChange={(e, val) =>
                          this.setState({ prixSec: val.value })
                        }
                      />
                      <Label id="inputMontantLabel">{t("label_modal_€")}</Label>
                    </Input>
                  </Segment>
                </Form.Field>
              </Form>
            </Container>
          </Modal.Description>
        </Modal.Content>
        <div class="ui divider" />
        <Modal.Actions id="footerModalDocument">
          <Button id="cancelBtnDevisModal">{t("button_modal_exit")}</Button>
          <Button
            id="submitBtnDevisModal"
            onClick={() => callbackNewDevis(this.state)}
          >
            <Icon name="checkmark" id="checkmarkIcon" />
            {t("button_modal_save")}
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default translate("ProModalDevisDoc")(ModalDevisDocument)



// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/BodyDevisEtFactures/ModalDevisDocument.js